<h2>Characteristics <button class="icon--add btn--default" type="button" *ngIf="canEdit" (click)="addCharacteristic()">Add Characteristic</button><button class="icon--history btn--default" type="button" (click)="showHistory(customerNumber)">View History</button></h2>
<p-table #dt 
         [value]="characteristics" 
         styleClass="p-datatable-striped">
    <ng-template pTemplate="header">
        <tr>
            <th>Type</th>
            <th>Effective Date</th>
            <th>Expiration Date</th>
            <th class="w--icon" *ngIf="canEdit">Edit</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="3 + (!!canEdit ? 1 : 0)">
                No records found
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData>
        <tr [pSelectableRow]="rowData">
            <td>{{rowData.characteristicType}}</td>
            <td>{{rowData.effectiveDate | shortDate}}</td>
            <td>{{rowData.endDate | shortDate}}</td>
            <td class="text-center" *ngIf="canEdit"><a class="icon--edit" title="Edit Characteristic" href="javascript:void(0);" (click)="editCharacteristic(rowData.id)" *ngIf="(rowData.customerCharacteristicTypeId != 40 || canEditRedactedRecord) && accommodationEditClearance(rowData)"></a></td>
        </tr>
    </ng-template>
</p-table>